import styled from 'styled-components'
import hiddenStyle from 'styles/hidden'

export const VisuallyHidden = styled.span`
  ${hiddenStyle(true)}
`
